import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_2 = {
  key: 1,
  class: "tw-saved-filters"
}
const _hoisted_3 = { class: "tw-saved-filters-inner row" }
const _hoisted_4 = { class: "tw-saved-filters-label" }
const _hoisted_5 = { class: "tw-saved-filters-number" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_facebook = _resolveComponent("q-spinner-facebook")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_spinner_facebook, {
          size: "2em",
          color: "primary"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfFilters, (filter, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "tw-saved-filters-box col-lg-4 col-md-4 col-sm-4 col-xs-6"
            }, [
              _createVNode(_component_q_btn, {
                color: filter.color,
                class: "btn mb-3",
                onClick: ($event: any) => (_ctx.onSelectedFilter(filter))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(filter.description), 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(filter.count), 1),
                  (_ctx.checkFilterActionPermission(_ctx.currentUserDAAQ.deleteAllowed, filter.daaq, filter.hasPublicAccess))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "tw-saved-filters-delete",
                        onClick: _withModifiers(($event: any) => (_ctx.onDeleteFilter(filter)), ["stop"])
                      }, [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                      ]))], 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  (_ctx.checkFilterActionPermission(_ctx.currentUserDAAQ.updateAllowed, filter.daaq, filter.hasPublicAccess))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "tw-saved-filters-cta",
                        onClick: _withModifiers(($event: any) => (_ctx.onEditFilter(filter)), ["stop"])
                      }, [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("i", { class: "fa fa-pen" }, null, -1)
                      ]))], 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["color", "onClick"])
            ]))
          }), 128))
        ])
      ]))
}